import React from 'react'

const SVGArrow = ({color, style}) =>
  <div style={style}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.104 20.455">
      <path fill={color} d="M20.417,11.6h-19a1.393,1.393,0,0,1-.138-2.783c.086,0,.17,0,.256,0H20.417c-.154-.163-.275-.3-.4-.432Q17.145,5.346,14.271,2.31a1.445,1.445,0,0,1-.01-1.973A1.372,1.372,0,0,1,15.677.059a1.976,1.976,0,0,1,.9.634c1.134,1.2,2.274,2.4,3.411,3.606l4.458,4.708c.077.08.157.16.231.243a1.4,1.4,0,0,1-.022,1.941q-3.122,3.3-6.251,6.6c-.682.721-1.38,1.428-2.043,2.168a1.555,1.555,0,0,1-2.088.138,1.322,1.322,0,0,1-.333-1.428,1.559,1.559,0,0,1,.32-.544q3-3.195,6.024-6.376C20.321,11.71,20.356,11.671,20.417,11.6Z" transform="translate(0.046 0.018)"/>
    </svg>
  </div>
///

export default SVGArrow;